// Validate links authored for public notices, not merely URL parser syntax.
// A domain-shaped address is required; this does not check DNS or reachability.
export function normalizeRichTextLink(value) {
  const input = value.trim();
  if (!input || /[\s<>\\\u0000-\u001f\u007f]/.test(input)) return null;
  const isDomain = hostname => {
    const labels = hostname.replace(/\.$/, '').split('.');
    return hostname.length <= 253 && labels.length > 1 &&
      labels.every(label => /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i.test(label)) &&
      /^(?:[a-z]{2,63}|xn--[a-z0-9-]+)$/i.test(labels[labels.length - 1]);
  };
  try {
    const url = /^[a-z][a-z0-9+.-]*:/i.test(input) ? input : 'https://' + input.replace(/^\/\//, '');
    const link = new URL(url);
    if (/^https?:$/.test(link.protocol)) {
      if (!/^https?:\/\/[^/]/i.test(url) || link.username || link.password || !isDomain(link.hostname)) return null;
    } else if (link.protocol === 'mailto:') {
      const parts = decodeURIComponent(link.pathname).split('@');
      if (parts.length !== 2 || !/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+$/i.test(parts[0]) ||
          /^\.|\.$|\.\./.test(parts[0]) || !isDomain(parts[1]) || link.hash) return null;
    } else if (link.protocol === 'tel:') {
      const number = decodeURIComponent(link.pathname);
      if (!/^\+?[0-9().-]+$/.test(number) || number.replace(/\D/g, '').length < 3 || link.search || link.hash) return null;
    } else {
      return null;
    }
    return link.href;
  } catch (_) {
    return null;
  }
}
